import { render, staticRenderFns } from "./statistical.vue?vue&type=template&id=6c1fbc75"
import script from "./statistical.vue?vue&type=script&lang=ts"
export * from "./statistical.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports